import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/store';
import { FlowSyncAccessPolicy, isAuthorized } from '../../models/FlowSyncAccessPolicy';
import ReservedValues from './InstanceConfiguration/ReservedValues';
import MergePersons from './InstanceConfiguration/MergePersons';
import PurgeAfterDays from './InstanceConfiguration/PurgeAfterDays';


const InstanceConfig = () => {
    const { t } = useTranslation(['configuration', 'common']);

    const authorizedAccessPolicies = useSelector<RootState, FlowSyncAccessPolicy[]>(state => state.me.me?.authorizedAccessPolicies ?? []);
    const hasEditAccess = isAuthorized(authorizedAccessPolicies, FlowSyncAccessPolicy.EDIT_MODULE);

    return <div className="padding-40 container single">
        <h1>{t('instanceSettings.title', { ns: 'configuration' })}</h1>
        <p>{t('instanceSettings.infoText', { ns: 'configuration' })}</p>

        <MergePersons hasEditAccess={hasEditAccess} />
        <PurgeAfterDays hasEditAccess={hasEditAccess} />
        <ReservedValues hasEditAccess={hasEditAccess} />
    </div>;
}

export default InstanceConfig;
